 const BASE_URL = "https://myshelta.com/shelterbackend/public/api/";
//const BASE_URL = "https://myshelta.com/Testbackend/public/api/";

import store from '../store';
// import router from '@/router'

// import Vue from 'vue';

// bodyType = "json" or "FormData"

export default function client({ URL_PATH, method, body, bodyType = "json" }) {
  return new Promise((resolve, reject) => {
    let options = {
      method: method,
      mode: "cors"
    };

    // let token = null;

    // let user = JSON.parse(localStorage.getItem('smartUser'))
    // let token = JSON.parse(localStorage.getItem('smartToken'))
    
    if (bodyType !== "FormData") {
      options.headers = {
        Accept: "application/json",
        "Content-Type": "application/json",
        // Authorization: `Bearer ${token}`,
        Authorization: `Bearer ${store.getters.getUser.token}`,
        shelta: "web"
      };
      // console.log("userrrrr", localStorage.getItem('smartUser').token);
    } else {
      options.headers = {
        // Authorization: `Bearer ${token}`,
        Authorization: `Bearer ${store.getters.getUser.token}`,
        shelta: "web"
      };
      // console.log("userrrrr", localStorage.getItem('smartUser').token);
    }

    if (body) {
      options.body = body;
    }

    fetch(`${BASE_URL}${URL_PATH}`, options)
     //.then(response => response.json())
      .then(response => {
        return response.json();

        // const lastpart =  window.location.href.split('/').pop();
        // let regexnum = /^R\d+$/;
        // const finalpath = regexnum.test(lastpart)
       
        // console.log("Responseeeeeee", response)
        // if (response.status == 401 && router.currentRoute.value == 'https://smart.myshelta.com/recoverpassword') {
        //   return;
        // }
        // if (finalpath === true) {
        //   console.log("check in", window.location.href)
        //   return;
        // } 
        // || window.location.href == 'https://smart.myshelta.com/:R'
        // window.location.href == 'https://smart.myshelta.com/recoverpassword/:token'
        // if (`http://localhost:${window.location.port}/recoverpassword/`) {
        //   console.log("Recover password chck", window.location.href)
        //   // localStorage.clear();
        //   // window.location.href = 'https://smart.myshelta.com/'; // Redirect to login page
        //   return;
        // } 
        
        
        // if (response.status == 401 && BASE_URL == "https://myshelta.com/shelterbackend/public/api/" && window.location.href !== 'https://smart.myshelta.com/' && window.location.href != 'https://smart.myshelta.com/recoverpassword') {
        //   localStorage.clear();
        //   window.location.href = 'https://smart.myshelta.com/'; // Redirect to login page
        //   return;
        // } 
        // if (response.status == 401 && BASE_URL == 'https://myshelta.com/Testbackend/public/api/' && window.location.hostname !== "localhost" && window.location.href !== 'https://smarttest.myshelta.com/' && window.location.href != 'https://smart.myshelta.com/recoverpassword') {
        //   localStorage.clear();
        //   window.location.href = 'https://smarttest.myshelta.com/'; // Redirect to login page
        //   return;
        // }
        // if (response.status == 401 && window.location.hostname === "localhost" && window.location.href !== `http://localhost:${window.location.port}/` && window.location.href != 'https://smart.myshelta.com/recoverpassword') {
        //   localStorage.clear();
        //   window.location.href = '/'; // Redirect to login page
        //   return;
        // } 

        // if (response.status == 401 && (window.location.href != `http://localhost:${window.location.port}/recoverpassword/:token` || window.location.href != 'https://smart.myshelta.com/recoverpassword/:token')) {
        //   localStorage.clear();
        //   window.location.href = '/'; // Redirect to login page
        //   return;
        // }
        // if (response.status == 401) {
        //   console.log("response")
        //   // localStorage.clear();
        //   // window.location.href = '/'; // Redirect to login page
        //   return;
        // }
        
        // else {
        //   return response.json();
        // }
      })
      .then(data => {
        resolve(data);
      })
      .catch(error => {
        reject(error);
    });
  });
}
